import { Injectable, inject } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { EncryptDecryptService } from '../encrypt-decrypt.service';
import { RolesService } from '../roles.service';
import { SharedService } from '../shared/shared.service';
import { StorageService } from '../storage.service';




@Injectable()
export class AuthGuard  {
    constructor(private router: Router, private storageService: StorageService
    , private encryptDecryptService: EncryptDecryptService,
    private rolesService : RolesService,
    private sharedService: SharedService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
        if (!this.encryptDecryptService.hasPassPhrase())
        {
            let country = this.storageService.decodeValue("Country");
      if (country !== "KSA") {

          return new Promise(res => {
              let country = this.storageService.decodeValue("Country");
              let countryName = this.storageService.decodeValue("CountryName");
              let flagLocation =  this.storageService.decodeValue("CountryFlagLocation");
              this.rolesService.getPassPhrase(country).subscribe(
                  async (resp: any) => {
                      let decryptedResponse = this.encryptDecryptService.decryptWithDefault(resp.response);
                      let response = JSON.parse(decryptedResponse);
                      if (!!response.data) {

                        if(country == "MIS"){
                          if(!!response.id)
                            this.storageService.encodeValue("UserId",response.id);
                          try {
                            const Feedback: any = await this.sharedService.enableClientFeedback();
                            if (Feedback.additionalPermission == "Feedback") {
    
    
                              if (Feedback) {
                                let data = {
                                  "feebackEnable": Feedback?.additionalPermission =="Feedback" ? true : false,
                                  "countryDetails": Feedback?.countryDetails,
                                  "groupDetails": Feedback?.groupDetails
                                }
                                this.sharedService.setClientFeedbackgroupDetails(data)
                                this.sharedService.emitsetClientFeedbackgroupDetails()
                              }
                            }else{
                              let data = {
                                "feebackEnable": false,
                                "countryDetails": [],
                                "groupDetails": []
                              }
                              this.sharedService.setClientFeedbackgroupDetails(data)
                              this.sharedService.emitsetClientFeedbackgroupDetails()
                            }
                          } catch (err) {
                            let data = {
                              "feebackEnable": false,
                              "countryDetails": [],
                              "groupDetails": []
                            }
                            this.sharedService.setClientFeedbackgroupDetails(data)
                            this.sharedService.emitsetClientFeedbackgroupDetails()
                            console.error("Error in fetching feedback", err);
                          }
    
                        }


                          this.encryptDecryptService.setPassPhrase(response.data);
                          let isAllowed = false;
                          if (!this.encryptDecryptService.hasPassPhrase()) return false;
                          if (
                              (state.url.indexOf('/home/dashboard') > -1 ||
                              state.url.indexOf('/home/onboarding') > -1 ||
                              state.url.indexOf('/home/permissionaccess') > -1 ||
                              state.url.indexOf('/home/superadmin') > -1) ||
                              state.url.indexOf('/home/mis-dashboard') > -1
                          ) {
                              isAllowed = true;
                          }
    
                          if(response.access === "CLIENT USER") {
                              isAllowed = false;
                              alert("You don't have authorized to access Global Admin Tool. Hence logging out")
                              this.storageService.logOut(false);
                              return res(false);
                          } 
                          if (country === 'MIS' && !response?.access.includes('MIS')) {
                              alert("You don't have authorized to access Global Admin Tool. In case any queries, please reach out to helpdesk for assistance/support");
                              return res(false);
                          }
                          if (this.storageService.tokenValidateTime()) {
                              isAllowed = true;
                          }
                          res(isAllowed);
                      } else {
                          alert("You don't have authorized to access Global Admin Tool. In case any queries, please reach out to helpdesk for assistance/support");
                          res(false);
                      }
                      if(!!response.id)
                      this.storageService.encodeValue("UserId",response.id);

                    

                  
                      if(!!response.userIds)
                          this.storageService.encodeValue("ApplicableUsers",response.userIds);
    
                      if(!!response.users)
                          this.storageService.encodeValue("ApplicableUserNames",response.users);
    
                      if(!!response.currentUser)
                          this.storageService.encodeValue("CurrentUser",response.currentUser);
    
                      if(!!response.access)
                          this.storageService.encodeValue("CurrentUserAccess",response.access);
    
                      this.sharedService.setcountryCode(country);
                      this.sharedService.setcountryName(countryName);
                      this.sharedService.setCountryFlagLocation(flagLocation)
                      this.sharedService.emitCountryCodeChange();
                      this.sharedService.emitCountryNameChange();
                      this.sharedService.emitCountryFlagLocationChange();
                }, (error) => {
                  if (error.status === 401 || error.status === 403) {
                    alert('Your session has expired. Please login again. Hence logging out.');
                    this.storageService.logOut(false);
                  } else {
                    alert("Something went wrong. Please try again later or reach out to helpdesk for assistance/support.");
                  }
                  res(false);
                }
              );
          });
      }else{
        return new Promise((res) => { 
            this.rolesService.checkValidKSAUser().subscribe(
              (resp: any) => {
                if (!!resp.data) {
                  this.encryptDecryptService.setPassPhrase(resp.data);
                  let isAllowed = false;
                  if (!this.encryptDecryptService.hasPassPhrase()) return false;
  
                  // this.rolesService.getAdminUser().subscribe(
                  //   (resp: any) => {
                  //       console.log(resp)
                  //       if(resp.hdr.status =='S'){

                       
                        if (
                            state.url.indexOf("/home/ksa/data-status/file-upload") > -1 ||
                            state.url.indexOf("/home/ksa/data-status/file-status") > -1 ||
                            state.url.indexOf("/home/ksa/data-status/api") > -1 ||
                            state.url.indexOf("/home/ksa/invoice-mgnt") > -1 ||
                            state.url.indexOf("/home/ksa/reports") > -1 ||
                            state.url.indexOf("/home/ksa") > -1 ||
                            state.url.indexOf("/home") > -1
                          )
                            isAllowed = true;
                    //     }else{
                    //         alert("Please reach out to helpdesk for assistance/support");
                    //         console.log("error in api call for get all group codes");
                    //         location.reload();
                    //         res(false);
                    //     }
                    // },(err)=>{
                    //     alert("Please reach out to helpdesk for assistance/support");
                    //         console.log("error in api call for get all group codes");
                    //         location.reload();
                    //         res(false);
                    // })

                  
                  // if (this.storageService.tokenValidateTime())
                  //     isAllowed = true;
  
                  this.storageService.encodeValue("policy", "Y");
                  res(isAllowed);
                } else {
                  alert("You are not authorized to access the portal.");
                  res(false);
                }
              },
              (error) => {
                if (error.status === 401 || error.status === 403) {
                  alert('Your session has expired. Please login again. Hence logging out.');
                  this.storageService.logOut(false);
                } else if(error.status === 409) {
                  console.log("Duplicate session found");
                } else
                  alert("Something went wrong. Please try again later or reach out to helpdesk for assistance/support.");
                res(false);
              }
            );
          });
      }

        } else {
            let isAllowed = false;
            if (!this.encryptDecryptService.hasPassPhrase()) return false;
            if (
                (state.url.indexOf('/home/dashboard') > -1 ||
                state.url.indexOf('/home/onboarding') > -1 ||
                state.url.indexOf('/home/permissionaccess') > -1 ||
                state.url.indexOf('/home/superadmin') > -1 ) ||
                state.url.indexOf('/home/mis-dashboard') > -1
            ) {
                isAllowed = true;
            }

            if (this.storageService.tokenValidateTime()) {
                isAllowed = true;
            }
            return isAllowed;
        }
    }
}

export const AuthGuardService: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(AuthGuard).canActivate(route, state);
}